import React, { useCallback, useEffect, useState } from 'react'
import { BuilderComponent, builder } from '@builder.io/react'
import PropTypes from 'prop-types'
import { getLocale, DEFAULT_LOCALE } from 'helpers/getLocale'
import '@builder.io/widgets'
import { axios } from 'api'
import useCategoryPill from 'hooks/useCategoryPill'

// Determine the API key based on the URL
const builderPublicApiKey =
  window?.REACT_ENV_VARIABLES?.BUILDER_PUBLIC_API_KEY ||
  '61e2402350ce4c0cbc02c5526b936de4'

// Init builder.io with the appropriate key
builder.init(builderPublicApiKey)

const BuilderSection = ({
  user,
  eventName,
  builderModelname,
  data: config
}) => {
  const [data, setData] = useState()
  const [content, setContent] = useState(null)
  const [locale, setLocale] = useState()
  useCategoryPill({ builderModelname, data })

  const fetchListing = useCallback(
    (loc) => {
      const baseUrl = config.fetchDataFrom?.replace('/api/v2', '')
      if (baseUrl) {
        axios
          .get(baseUrl)
          .then((res) => setData(res.data))
          .catch((err) => console.log(err))
      } else {
        setData(config)
      }
    },
    [config]
  )

  useEffect(() => {
    const loadSchema = async () => {
      let locale = new URLSearchParams(window.location.search).get('locale')
      if (locale) {
        fetchListing(locale)
      } else {
        locale = DEFAULT_LOCALE
        try {
          locale = await getLocale()
        } catch (err) {
          console.log(err)
        }
        fetchListing(locale)
      }
      setLocale(locale)
    }
    loadSchema()
  }, [fetchListing])

  // Fetch the Builder content with the current locale, refetching when it changes.
  useEffect(() => {
    if (!locale) return
    const userAttributes = {
      locale,
      ...(user.urlPath ? { urlPath: user.urlPath } : {})
    }

    builder
      .get(builderModelname, { userAttributes })
      .toPromise()
      .then((fetchedContent) => setContent(fetchedContent))
      .catch((error) => console.error('Error fetching Builder data:', error))
  }, [builderModelname, user, locale])

  const transformData = (data) => {
    if (builderModelname === 'category-pill-listing' && Array.isArray(data)) {
      return data.map((item) => ({
        buttonTitle: item.categoryName,
        buttonLink: `/class-finder?styles=${item.categorySlug}&order=date`
      }))
    }
    return data
  }

  return (
    <div>
      {content ? (
        <BuilderComponent
          model={builderModelname}
          content={content}
          {...(data && {
            data: { data: transformData(data), gaEventName: eventName }
          })}
        />
      ) : (
        <p>Loading...</p>
      )}
    </div>
  )
}

BuilderSection.propTypes = {
  user: PropTypes.object.isRequired,
  builderModelname: PropTypes.string.isRequired,
  data: PropTypes.object
}

BuilderSection.defaultProps = {
  user: {},
  data: {}
}

export default BuilderSection
